<template>
  <div :class="containerClassName">
    <component
      :is="directoryIcon"
      v-if="directoryIcon"
      :class="$style.icon"
      :name="item.type"
    />
  </div>
</template>
<script>
import { DirectoryTypeConsts } from 'client/util/Constants';
import { values } from 'lodash';
import ActiveDirectoryIcon from 'public/img/icons/adBridgeAvatar.svg?inline';
import BambooHRIcon from 'public/img/icons/bamboo-hr.svg?inline';
import GoogleIcon from 'public/img/icons/google-workspace.svg?inline';
import LDAPIcon from 'public/img/icons/ldap.svg?inline';
import M365Icon from 'public/img/icons/microsoft365.svg?inline';
import OktaIcon from 'public/img/icons/okta.svg?inline';
import PersonioIcon from 'public/img/icons/personio.svg?inline';
import WorkdayIcon from 'public/img/icons/workdayAvatar.svg?inline';
import icons from 'client/css/icons.css';

const {
  activeDirectory,
  bambooHR,
  gSuite,
  ldapServer,
  office365,
  okta,
  personio,
  workday,
} = DirectoryTypeConsts;

const iconMap = {
  [activeDirectory]: ActiveDirectoryIcon,
  [bambooHR]: BambooHRIcon,
  [gSuite]: GoogleIcon,
  [ldapServer]: LDAPIcon,
  [office365]: M365Icon,
  [okta]: OktaIcon,
  [personio]: PersonioIcon,
  [workday]: WorkdayIcon,
};

export default {
  name: 'DirectoryTypeIcon',

  props: {
    item: {
      type: Object,
      required: true,
      validator: item => !!(item && values(DirectoryTypeConsts).indexOf(item.type) !== -1),
    },
    smallIcon: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    const data = {
      containerClassName: [
        icons.iconStack,
        this.smallIcon
          ? this.$style.containerSmall
          : this.$style.containerLarge,
      ],
      directoryIcon: iconMap[this.item.type],
    };

    return data;
  },
};
</script>
<style scoped module>
.containerLarge {
  height: 26px;
  width: 26px;
}

div.containerSmall {
  height: 21px;
  vertical-align: -10%;
  width: 21px;
}

.icon {
  height: 100%;
  width: 100%;
}
</style>
